﻿import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({    
    templateUrl: 'applicant-portal.component.html'
})

export class ApplicantPortalComponent {
}